import { IonContent, IonFooter, IonHeader } from '@ionic/react';
import useBasket from '../../../../../hooks/basket/useBasket';
import CartIcon from '../../../assets/icons/CartIcon';
import Button from '../../../components/buttons/Button';
import useRouter from '../../../../../hooks/navigation/useRouter';
import { Modals, Routes } from '../../../exports/Enums';
import useModalRouter from '../../../common/hooks/useModalRouter';
import { useTranslation } from 'react-i18next';
import { CompiledProduct } from '../../../../../providers/MenuProvider';
import classNames from 'classnames';
import { swipeableCssClass } from '../../../exports/Constants';
import classnames from 'classnames';
import { useState } from 'react';
import AppliedOfferToast from '../../../../../features/offers/components/AppliedOfferToast';
import OrderMethodToolbar from '../../../modals/order-method/OrderMethodToolbar';
import MenuCategoryList from '../../../../../components-library/menu/category-list/MenuCategoryList';
import MenuList from '../../../../../components-library/menu/category-list/MenuList';
import MenuBarSearch from '../../../../../components-library/menu/MenuNavigationBar/MenuBarSearch';
import MenuBar from '../../../../../components-library/menu/MenuNavigationBar/MenuBar';
import { MenuCategoryListProvider } from '../../../../../components-library/menu/category-list/MenuCategoryListProvider';

export const MENU_TAB_CONTENT_ID = 'menuTabContentId';

const MenuTab = () => {
  const { basketItemsCount } = useBasket();
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Pages:Tabs:Menu:MenuTab' });
  const { navigate } = useRouter();
  const { openModal, closeModal, isOpen } = useModalRouter();
  const [loadingNavigation, setLoadingNavigation] = useState<boolean>(false);

  const onProductClick = (product: CompiledProduct): void => {
    if (isOpen) {
      return;
    }

    openModal({
      id: Modals.MenuItem,
      presentation: {
        initialBreakpoint: 1,
        breakpoints: [0, 1],
        handle: false,
        cssClass: classnames(swipeableCssClass),
      },
      props: {
        openModal: true,
        product: product,
        onCloseModal: () => closeModal(Modals.MenuItem),
      },
    });
  };

  return (
    <>
      <MenuCategoryListProvider>
        <StickyHeader />
        <IonContent
          scrollEvents={true}
          id={MENU_TAB_CONTENT_ID}
          className={classNames('relative', {
            '[&::part(scroll)]:pb-[calc(100px)]': basketItemsCount > 0,
            '[&::part(scroll)]:pb-[calc(10px)]': basketItemsCount === 0,
          })}
        >
          <MenuList />
          <MenuCategoryList.MenuBar className="sticky top-0 z-50 border-b-xs bg-brand-background-primary" />
          <MenuCategoryList onProductClick={onProductClick} skipProvider className="bg-slate-50 dark:bg-black pt-md" />
        </IonContent>
      </MenuCategoryListProvider>
      {basketItemsCount > 0 && (
        <IonFooter className="pb-7 fixed bottom-0 px-md bg-transparent w-full space-y-3">
          <AppliedOfferToast />
          <Button
            className="relative"
            loading={loadingNavigation}
            onClick={() => {
              setLoadingNavigation(true);
              setTimeout(() => {
                setLoadingNavigation(false);
                navigate({
                  mobile: {
                    path: Routes.Cart,
                  },
                });
              }, 500);
            }}
          >
            <>
              <span className="absolute left-md">
                <CartIcon className="w-4 stroke-white" />
              </span>
              <span className="absolute right-md">{basketItemsCount}</span>
              {t('buttons.go_to_basket')}
            </>
          </Button>
        </IonFooter>
      )}
    </>
  );
};

const StickyHeader = () => {
  return (
    <IonHeader>
      <div className="safe-area-top w-full bg-white" />
      <div className="p-md w-full flex justify-between items-center border-b border-brand-border bg-brand-background-primary">
        <OrderMethodToolbar className="bg-white !border-mobile-notice relative !p-0 border-none ml-0">
          <OrderMethodToolbar.OrderMethodDetails className="text-muted-foreground !justify-start !items-start text-xs !font-normal" />
          <OrderMethodToolbar.CompanyName className="text-black !text-sm !font-semibold text-start" />
        </OrderMethodToolbar>
        <div className="flex gap-xs">
          <MenuBarSearch />
          <MenuBar.MenuButton />
        </div>
      </div>
    </IonHeader>
  );
};

export default MenuTab;
